export function PageFooter({ productName }) {
  return (
    <footer className="page-footer">
      <div className="footer-links">
        <a href="/">{productName}</a>
        <a href="/support">サポート</a>
        <a href="/privacy">プライバシーポリシー</a>
      </div>
      <span>© {new Date().getFullYear()} NASLink</span>
    </footer>
  );
}
